import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  currentFiltersSelector,
  SBAT_GROUP_FILTERS,
  setFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import InstructorSelect from 'components/InstructorSelect';

function InstructorsFilter() {
  const dispatch = useDispatch();
  const { primaryInstructors, secondaryInstructors } = useSelector(
    currentFiltersSelector
  );
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handlePrimaryInstructorsChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.primaryInstructors,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  const handleSecondaryInstructorsChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.secondaryInstructors,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <>
      <Field
        label="Primary Instructor Name"
        labelClassName="h5"
        className="m-t-xs"
      >
        <InstructorSelect
          isMulti
          value={primaryInstructors}
          placeholder="Select primary instructor"
          styles={_styles}
          className="m-b-s"
          onChange={handlePrimaryInstructorsChange}
        />
      </Field>
      <Field
        label="Secondary Instructor Name"
        labelClassName="h5"
        className="m-t-xs"
      >
        <InstructorSelect
          isMulti
          value={secondaryInstructors}
          placeholder="Select secondary instructor"
          styles={_styles}
          className="m-b-s"
          onChange={handleSecondaryInstructorsChange}
        />
      </Field>
    </>
  );
}

export default InstructorsFilter;
